import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import trophyIcon from '@/assets/app/images/icon/icon-trophy.png';
import useAppStore from '@/shared/store/UseAppStore';
import { getUploadsUrl, vAppAjax } from '@/shared/utils/CommonUtil';
import logger from '@/shared/utils/Logger';
import BookPerson from './BookPerson';

const Book: React.FC = () => {
  const navigate = useNavigate();
  const { setIsShowBottomNavigation, setIsShowProfileHeader } = useAppStore();
  const [list, setList] = useState<BookEraCategory[]>([]);
  const [eraCategory, setEraCategory] = useState<BookEraCategory>();
  const [showPerson, setShowPerson] = useState(false);

  const loadData = async () => {
    await vAppAjax(
      'get',
      `my/book`,
      {},
      (response: AxiosResponse<CommonResult>) => {
        const resultData = response.data;
        if (resultData.code === 200) {
          setList(response.data.result);
        } else {
          logger.warn(resultData.message);
        }
      },
      (error: any) => {
        logger.error(error);
      },
    );
  };

  useEffect(() => {
    setIsShowBottomNavigation(true);
    setIsShowProfileHeader(true);
    loadData();
  }, []);

  const handleShowPerson = (category: BookEraCategory) => {
    setEraCategory(category);
    setShowPerson(true);
    // if (character.unlocked) {
    //   // 캐릭터 상세 정보 표시
    //   console.log('Character clicked:', character.name);
    // }
  };

  if (list.length === 0) {
    return <></>;
  }

  return (
    <Fragment>
      <div className="page-container page-container--white" style={{ padding: 20 }}>
        <div
          className="flex"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            columnGap: 16,
            justifyItems: 'center',
            rowGap: 15,
          }}
        >
          {list.map((item, idx) => {
            const percentage = Math.min(
              Math.max((item.completedPerson / item.totalPerson) * 100, 0),
              100,
            );
            return (
              <div
                style={{
                  position: 'relative',
                }}
                onClick={() => handleShowPerson(item)}
              >
                <div
                  style={{
                    position: 'relative',
                    border: `6px solid ${item.themeColor}`,
                    overflow: 'hidden',
                    borderRadius: 14,
                  }}
                >
                  <h2
                    className="text-white mb-6 text-outline-black absolute left-1/2 -translate-x-1/2 w-full text-center top-[1px]"
                    style={{ fontSize: 14, fontFamily: 'SUIT' }}
                  >
                    {item.categoryName}
                  </h2>
                  <img src={`${getUploadsUrl()}/person/${item.imageFilename}`} />{' '}
                  <div
                    className="bg-[#072B5D] text-center"
                    style={{
                      position: 'absolute',
                      width: '100%',
                      bottom: 0,
                      fontSize: 12,
                      fontWeight: 800,
                      height: 15,
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      className="h-full bg-[#14A1C8] transition-all duration-500 ease-out relative"
                      style={{ width: `${percentage}%`, borderRadius: 4 }}
                    >
                      {/* 2. 상단 8px 하이라이트 (흰색 20%) */}
                      <div className="absolute top-0 left-0 w-full h-[8px] bg-white/20" />
                    </div>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <span className="text-white text-[10px] font-extrabold leading-none shadow-sm">
                        {item.completedPerson}/{item.totalPerson}
                      </span>
                    </div>
                  </div>
                </div>

                {item.totalPerson === item.completedPerson && (
                  <img
                    style={{
                      position: 'absolute',
                      bottom: -6,
                      right: -12,
                      width: 50,
                      height: 'auto',
                    }}
                    src={trophyIcon}
                  />
                )}
              </div>
              // <CategoryCard key={idx} category={item} />
            );
          })}
        </div>
      </div>
      {showPerson && <BookPerson closeFunc={() => setShowPerson(false)} category={eraCategory} />}
    </Fragment>
  );
};

export default Book;
